import { AVERAGE_PERCENTAGE } from "./constants";

type FinanceProvider = {
  interest_rate?: string | number;
  is_active?: boolean;
};

export const getLowestActiveInterestRate = (
  providers: FinanceProvider[] | null | undefined,
  fallbackRate = AVERAGE_PERCENTAGE
) => {
  if (!Array.isArray(providers)) return fallbackRate;

  const lowestActiveRate = providers.reduce((lowestRate, provider) => {
    const interestRate = Number(provider?.interest_rate);

    if (
      !provider?.is_active ||
      !Number.isFinite(interestRate) ||
      interestRate <= 0
    ) {
      return lowestRate;
    }

    return Math.min(lowestRate, interestRate);
  }, Number.POSITIVE_INFINITY);

  return Number.isFinite(lowestActiveRate)
    ? lowestActiveRate
    : fallbackRate;
};

export const calculateLoanAmountFromEMI = (
  emi: number,
  interest: number,
  tenure: number
) => {
  const r = interest / 12 / 100;
  return Math.round((emi * (1 - Math.pow(1 + r, -tenure))) / r);
};

export const calculateEMIFromLoanAmount = (
  loan: number,
  interest: number,
  tenure: number
) => {
  const r = interest / 12 / 100;
  return Math.round(
    (loan * r * Math.pow(1 + r, tenure)) / (Math.pow(1 + r, tenure) - 1)
  );
};
